import { Alert, Snackbar } from '@mui/material'
import { useAppDispatch, useAppSelector, hideSnackbar } from '@/store'

/**
 * GlobalSnackbar — app-wide toast notification.
 * Controlled by dispatch(showSnackbar({ severity, message })) from anywhere.
 * Rendered once in App.tsx.
 */
export const GlobalSnackbar = () => {
  const dispatch = useAppDispatch()
  const { open, severity, message } = useAppSelector((state) => state.ui.snackbar)

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={() => dispatch(hideSnackbar())}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        onClose={() => dispatch(hideSnackbar())}
        severity={severity}
        variant="filled"
        sx={{
          width: '100%',
          ...(severity === 'success' && {
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            '& .MuiAlert-icon, & .MuiAlert-action': {
              color: 'primary.contrastText',
            },
          }),
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}
